// extracted by mini-css-extract-plugin
export default {"mask":"CategoryDialog_mask__BpPXP","dialog":"CategoryDialog_dialog__cWhKO","list":"CategoryDialog_list__tyxEi","item":"CategoryDialog_item__KyNPI"};